<template>
  <div class="help-center-unavailable pa-4">
    <img
      src="@/flit2go-web-core/assets/permission_error.svg"
      class="help-center-unavailable__image"
      alt="help center unavailable"
    />
    <span class="help-center-unavailable__title my-2">{{
      $t("common.ops")
    }}</span>
    <span class="help-center-unavailable__text my-2">{{
      $t("helpCenterUnavailable")
    }}</span>
  </div>
</template>

<script>
// Shown instead of the Zoho help center when the user has no identity in Zoho (403 / 503) or the
// integration is off in this environment. Never opens the Zoho widget
export default {
  name: "HelpCenterUnavailable",
};
</script>

<style lang="scss" scoped>
.help-center-unavailable {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  &__image {
    height: 300px;
    width: 300px;
  }

  @media (max-width: 600px) {
    &__image {
      height: 200px;
      width: 200px;
    }
  }

  &__title {
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
  }

  &__text {
    font-size: 2rem;
    text-align: center;
  }
}
</style>
